import { Component, OnInit } from '@angular/core';
import { ApiService } from './../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-dynmicvacancy',
  templateUrl: './dynmicvacancy.component.html',
  styleUrls: ['./dynmicvacancy.component.css']
})
export class DynmicvacancyComponent implements OnInit {

  public url_id:any;
  public url_refid:any;
  public courseList:any;
  public courseList_sub_title:any;
  public courseList_sub_desc:any;
  constructor(private router2:ActivatedRoute, private api: ApiService) {
   // this.url_id = this.router2.snapshot.paramMap.get('id');
    this.url_refid = this.router2.snapshot.paramMap.get('id');

   }

  ngOnInit(): void {

    var args= {
     // id: this.url_id,
      refid: this.url_refid
    }

    this.api.listCoursespl(args).subscribe((result: any) => {
      this.courseList = result;
    });

    this.api.listjcvacancytitle(args).subscribe((result: any) => {
      for(let i=0; i<result.length; i++){

        console.log('a' + result[i]['id']);

        this.courseList_sub_title = result;

        var myargs = {
          refid: this.url_refid,
          jctitleid: result[i]['id']
        };

        // this.api.listjcvacancydesc(myargs).subscribe((result: any) => {
          
        //     this.courseList_sub_desc = result;
        //     console.log(this.courseList_sub_desc)


        // });

      }
      
    });

    this.api.listjcvacancydesc(args).subscribe((result: any) => {
      this.courseList_sub_desc = result;
    });
    
  }

}
